<template>
	<button
		:style="styleObj"
		class="cls-btn rounded-circle px-2"
		:class="classes"
		@click="(e) => handleClick(e)"
		@mouseover="state.hover = true"
		@mouseleave="state.hover = false"
	>
		<svg :width="iconSizes.xxs" :height="iconSizes.xxs" class="icon">
			<use :xlink:href="`#___icon___close-x`"></use>
		</svg>
	</button>
</template>

<script>
import colors from "@/config/colors";
import iconSizes from "@/config/iconSizes";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "ClsBtn",
	props: {
		stop: Boolean,
		prevent: Boolean,
		classes: {
			type: String,
			default: "",
		},
		background: {
			type: String,
			default: colors.lightGray,
		},
		hoverBackground: {
			type: String,
			default: colors.lightGray,
		},
		border: {
			type: String,
			default: "none",
		},
		hoverBorder: {
			type: String,
			default: "none",
		},
		color: {
			type: String,
			default: colors.black,
		},
		hoverColor: {
			type: String,
			default: colors.darkBlue,
		},
	},
	data() {
		return {
			colors,
			iconSizes,
			state: {
				hover: false,
			},
		};
	},
	computed: {
		styleObj() {
			return {
				background: this.state.hover ? this.hoverBackground : this.background,
				border: this.state.hover ? this.hoverBorder : this.border,
				color: this.state.hover ? this.hoverColor : this.color,
			};
		},
	},
	methods: {
		handleClick(e) {
			if (this.prevent) e.preventDefault();
			if (this.stop) e.stopPropagation();
			this.$emit("click");
		},
	},
};
</script>

<style scoped>
.cls-btn {
	cursor: pointer;
	display: block;
	align-items: center;
	justify-content: center;
}
</style>
